import { checkOnboarding } from '@/core/services/OnboardingChecker';
import { defineStore } from 'pinia';
import type { User } from '../types';

export const useAuthStore = defineStore('auth', () => {
  const { data } = useAuth();
  const user = ref<User>(data.value?.data || null);
  const getUser = computed(() => user.value || ({} as User));
  const hasLoggedInUser = computed(() => Boolean(user.value));
  const hasCompletedOnboarding = computed(() => user.value?.first_name && user.value?.last_name);
  const isVerified = computed(() => user.value?.email_verified);
  const onboardingCompleted = computed(() => checkOnboarding(getUser.value));
  const isHealthProfessional = computed(() => {
    switch (getUser.value?.role) {
      case 'EXTERNAL_HEALTH_PROFESSIONAL':
      case 'INTERNAL_HEALTH_PROFESSIONAL':
      case 'HEALTH_OFFICER':
        return true;
      default:
        return false;
    }
  });

  watch(
    () => data.value,
    () => {
      if (data.value?.data) {
        user.value = data.value?.data;
      }
    },
    { immediate: true }
  );

  return {
    user,
    getUser,
    hasLoggedInUser,
    hasCompletedOnboarding,
    isVerified,
    onboardingCompleted,
    isHealthProfessional,
  };
});
